module.exports = {
    host:'',
    port:'',
    base:'/timesloan',
    debug: false
}


// WEBPACK FOOTER //
// ./src/config.js